import { render, staticRenderFns } from "./path.vue?vue&type=template&id=2b293234&scoped=true&"
import script from "./path.vue?vue&type=script&lang=js&"
export * from "./path.vue?vue&type=script&lang=js&"
import style0 from "./path.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b293234",
  null
  
)

export default component.exports